import FormElementWrapper from "./FormElementWrapper";

import "./submitbutton.css";

export default function SubmitButton({value, className}) {

    return <FormElementWrapper className={className}>
        <input type="submit" value={value} name="submit"/>
    </FormElementWrapper>

}